import axios from "axios";
import { CONTENT_TOOLKIT_GATEWAY_URL } from "../config/app-config";
import { createRequestFunction } from "../create-api-client";
const client = axios.create({
  baseURL: CONTENT_TOOLKIT_GATEWAY_URL
});
function setClientBaseUrl(baseURL) {
  if (baseURL) {
    client.defaults.baseURL = baseURL;
  }
}
const toolkitClient = createRequestFunction(client);
export {
  client,
  setClientBaseUrl,
  toolkitClient
};
